/**
* @copyright Copyright (c) MITSUBISHI Electric Corporation. All rights reserved.
*/

import React, { useContext } from 'react';
import Toast from 'react-bootstrap/Toast';
import { IndexContext } from '../IndexProvider';

function Alert(props) {

    const { setMessage } = useContext(IndexContext)

    return (
        <>
            <div className="position-fixed" style={{ top: 0, left: "50%", zIndex: 1031, transform: "translateX(-50%)" }}>
                <Toast bg={props.variant.toLowerCase()} onClose={() => setMessage({variant: "Light", show: false, msg: "" })} show={props.show} delay={5000} autohide>
                    <Toast.Header>
                        <strong className="me-auto">[PEGADA] 通知</strong>
                        <small>{(new Date()).toLocaleString("ja-JP")}</small>
                    </Toast.Header>
                    <Toast.Body className={props.variant.toLowerCase() === 'dark' && 'text-white'} >{props.msg}</Toast.Body>
                </Toast>
            </div>
        </>
    );
}

export default Alert;